import moment from "moment";
import strings from "./strings";
import { t } from "../Utils/translate";
import "./constants.css";

const resendCodeTime = 30000;
const currentYear = moment().year();
const today = new Date();
let monthCurrentIs = today.getMonth() + 1;
let yearIs = today.getFullYear();
let currentDate = moment(CurrentDate).format(strings.format.DD);
const currentMonth = moment().month();
var _format = strings.format.date;
var CurrentDate = moment().format();
var dateTosend = moment(CurrentDate).format(_format);
const doctorLeaveMinDate = today.setDate(today.getDate() + 1);
const doctorLeaveMaxDate = new Date(today.getTime() + 60 * 24 * 60 * 60 * 1000);

const doctorTiming = {
    label_sunday: "SUNDAY",
    label_monday: "MONDAY",
    label_tuesday: "TUESDAY",
    label_wednesday: "WEDNESDAY",
    label_thursday: "THURSDAY",
    label_friday: "FRIDAY",
    label_saturday: "SATURDAY",
};

// const languageOptions = [
//     { value: "en", label: "English (en)", subTitle: 'English' },
//     { value: "vietnam", label: "Vietnamese (vi)", subTitle: 'Tiếng Việt' },
// ];
// const languageOptions = [
//   { value: "en", label: "English (en)", subTitle: "English" },
//   { value: "vietnam", label: "Vietnamese (vi)", subTitle: "Tiếng Việt" },
// ];

export const languageOptions = [
    { value: "en", label: <div className="language-option">English (en) </div>, subTitle: "English" },
    { value: "vietnam", label: <div className="language-option">Vietnamese (vi) </div>, subTitle: "Tiếng Việt" },
    // { value: "french", label: <div className="language-option">French (fr)</div>, subTitle: "Français" },
];



const sortedLanguageOptions = languageOptions.sort((a, b) =>
    a.label.props.children.localeCompare(b.label.props.children)
);


const dayList = [
    {
        day: doctorTiming.label_monday,
        displayDay: t("Monday"),
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_tuesday,
        displayDay: t("Tuesday"),
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_wednesday,
        displayDay: t("Wednesday"),
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_thursday,
        displayDay: t("Thursday"),
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_friday,
        displayDay: t("Friday"),
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_saturday,
        displayDay: t("Saturday"),
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_sunday,
        displayDay: t("Sunday"),
        status: false,
        limit: 3,
        timing: [],
    },
];

const emptyDayList = [
    {
        day: doctorTiming.label_monday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_tuesday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_wednesday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_thursday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_friday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_saturday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_sunday,
        status: false,
        limit: 3,
        timing: [],
    },
];

const dayListArr = [
    {
        day: doctorTiming.label_monday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_tuesday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_wednesday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_thursday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_friday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_saturday,
        status: false,
        limit: 3,
        timing: [],
    },
    {
        day: doctorTiming.label_sunday,
        status: false,
        limit: 3,
        timing: [],
    },
];

const timeValue = {
    from: "",
    to: "",
};

// const appointmentDetailsType = {
//     detailed: "DETAILED",
//     reusable: "REUSABLE",
//     medical: "Medical Notes",
//     generate: "Generate Medical Certificate",
//     viewEPrescription: "View e-prescription",
//     patientHealthRecords: "Patient health records",
//     calendarBased: "Create Appointment",
//     vitalSigns: "Vital Signs",
// };

const appointmentDetailsType = {
    detailed: {
        value: "Appointment Details",
        label: "DETAILED"
    },
    reusable: { value: "REUSABLE", label: "REUSABLE" },
    medical: { value: "Medical Notes", label: t("medicalNotes") },
    generate: { value: "Generate Medical Certificate", label: t("generateMedicalCertificate") },
    viewEPrescription: { value: "View e-prescription", label: t("viewEPrescription") },
    patientHealthRecords: { value: "Patient health records", label: t("patientHealthRecords") },
    calendarBased: { value: "Create Appointment", label: t("createAppointmentHeading") },
    vitalSigns: { value: "Vital Signs", label: t("vitalSigns") },
};


const doctorDepartmentList = [
    { value: "aurtho", label: "Aurtho" },
    { value: "surgeon", label: "Surgeon" },
    { value: "family-physician", label: "Family Physician" },
    { value: "gynecologist", label: "Gynecologist" },
    { value: "heart-Specialist", label: "Heart Specialist" },
    { value: "orthopedic", label: "Orthopedic" },
    { value: "gynaecologist", label: "Gynaecologist" },
    { value: "dentist", label: "Dentist" },
];

const languageList = [
    { value: "english", label: "English" },
    { value: "mandarin", label: "Mandarin" },
    { value: "bahasa", label: "Bahasa" },
    { value: "malayu", label: "Malayu" },
    { value: "Tagalog", label: "Tagalog" },
    { value: "tamil", label: "Tamil" },
    { value: "hindi", label: "Hindi" },
    { value: "urdu", label: "Urdu" },
    { value: "bengali", label: "Bengali" },
    { value: "marathi", label: "Marathi" },
    { value: "telugu", label: "Telugu" },
    { value: "gujarati", label: "Gujarati" },
    { value: "kannada", label: "Kannada" },
    { value: "odia", label: "Odia" },
    { value: "malayalam", label: "Malayalam" },
    { value: "others", label: "Others" },
    { value: "bangala", label: "Bangala" },
];

const appointmentState = {
    completed: "COMPLETED",
    started: "STARTED",
    confirmed: "CONFIRMED",
    waitingForClinicConfirmation: "WAITING_CLINIC_CONFIRMATION",
    rejected: "REJECTED",
    expired: "EXPIRED",
    waitingForPatientConfirmation: "WAITING_PATIENT_CONFIRMATION",
    reassign: "REASSIGN",
    pending: "PENDING",
    calendarCancelled: "CALENDER_CANCELLED",
    cancelled: "CANCELLED",
};

const hourOptions = [
    { value: '00', label: '12 AM' },
    { value: '01', label: '1 AM' },
    { value: '02', label: '2 AM' },
    { value: '03', label: '3 AM' },
    { value: '04', label: '4 AM' },
    { value: '05', label: '5 AM' },
    { value: '06', label: '6 AM' },
    { value: '07', label: '7 AM' },
    { value: '08', label: '8 AM' },
    { value: '09', label: '9 AM' },
    { value: '10', label: '10 AM' },
    { value: '11', label: '11 AM' },
    { value: '12', label: '12 PM' },
    { value: '13', label: '1 PM' },
    { value: '14', label: '2 PM' },
    { value: '15', label: '3 PM' },
    { value: '16', label: '4 PM' },
    { value: '17', label: '5 PM' },
    { value: '18', label: '6 PM' },
    { value: '19', label: '7 PM' },
    { value: '20', label: '8 PM' },
    { value: '21', label: '9 PM' },
    { value: '22', label: '10 PM' },
    { value: '23', label: '11 PM' },
];

const clinicState = {
    clinicContinuouslyClosed: "CLINIC_CONTINUESLY_CLOSED",
    clinicAdvancedBookingExceeded: "CLINIC_ADVANCE_BOOKING_EXCEDED",
};

const dosageList = [
    {
        label: "1-1-1 AF",
        value: "1-1-1 AF",
        total: 3,
        session: { morning: true, afterNoon: true, night: true },
        type: "AF",
    },
    {
        label: "0-1-1 AF",
        value: "0-1-1 AF",
        total: 2,
        session: { morning: false, afterNoon: true, night: true },
        type: "AF",
    },
    {
        label: "0-0-1 AF",
        value: "0-0-1 AF",
        total: 1,
        session: { morning: false, afterNoon: false, night: true },
        type: "AF",
    },
    {
        label: "1-0-0 AF",
        value: "1-0-0 AF",
        total: 1,
        session: { morning: true, afterNoon: false, night: false },
        type: "AF",
    },
    {
        label: "1-1-0 AF",
        value: "1-1-0 AF",
        total: 2,
        session: { morning: true, afterNoon: true, night: false },
        type: "AF",
    },
    {
        label: "0-1-0 AF",
        value: "0-1-0 AF",
        total: 1,
        session: { morning: false, afterNoon: true, night: false },
        type: "AF",
    },
    {
        label: "1-0-1 AF",
        value: "1-0-1 AF",
        total: 2,
        session: { morning: true, afterNoon: false, night: true },
        type: "AF",
    },
    {
        label: "1-1-1 BF",
        value: "1-1-1 BF",
        total: 3,
        session: { morning: true, afterNoon: true, night: true },
        type: "BF",
    },
    {
        label: "0-1-1 BF",
        value: "0-1-1 BF",
        total: 2,
        session: { morning: false, afterNoon: true, night: true },
        type: "BF",
    },
    {
        label: "0-0-1 BF",
        value: "0-0-1 BF",
        total: 1,
        session: { morning: false, afterNoon: false, night: true },
        type: "BF",
    },
    {
        label: "1-0-0 BF",
        value: "1-0-0 BF",
        total: 1,
        session: { morning: true, afterNoon: false, night: false },
        type: "BF",
    },
    {
        label: "1-1-0 BF",
        value: "1-1-0 BF",
        total: 2,
        session: { morning: true, afterNoon: true, night: false },
        type: "BF",
    },
    {
        label: "0-1-0 BF",
        value: "0-1-0 BF",
        total: 1,
        session: { morning: false, afterNoon: true, night: false },
        type: "BF",
    },
    {
        label: "1-0-1 BF",
        value: "1-0-1 BF",
        total: 2,
        session: { morning: true, afterNoon: false, night: true },
        type: "BF",
    },
];

const clinicProfileEditList = [
    {
        label: t("labelDoctorProfile"),
        value: "editProfile",
    }
];

const doctorEditList = [
    {
        label: t("labelDoctorProfile"),
        value: "editProfile",
    }
];

const chatRole = {
    sender: "CLINIC",
    receiver: "PATIENT",
    clinic: "CLINIC",
    patient: "PATIENT",
    system: "SYSTEM",
    doctor: "DOCTOR",
};

const dateFormat = {
    standardDate: "DD-MM-YYYY",
    timeWithMeridiem: "hh:mm A",
    standardDateYearFirst: "YYYY-MM-DD",
    formateDate: "YYYY MM DD",
    standardDateTime: "DD-MM-YYYY HH:mm",
    standardDateTimeWithSeconds: "YYYY-MM-DDTHH:mm:00",
    standardMonth: "MMMM DD",
    clinicDashboardDate: "dddd DD",
    dashboardformateDate: "ddd DD",
    yearMonthDate: "YYYY-MM-DD",
    formateDateWithHyphen: "YYYY-MM-DD",
    dateAndMonth: "DD MMM",
    dateTime: "DD/MMM/YYYY, hh:mm A",
    timeDifferenceToday: "YYYY-MM-DDTHH:mm:ss a",
    standardDateSlash: "DD/MM/YYYY"
};

const doctorType = {
    slot: "SLOT",
    calendar: "CALENDER",
};

const slotOptions = [
    { value: "00:00 - 23:59", label: "All" },
    { value: "00:00 - 12:00", label: "00:00 - 12:00" },
    { value: "12:00 - 23:59", label: "12:00 - 23:59" },
];

const consulationOptions = [
    { value: "VideoCall", label: "VideoCall" },
    { value: "AudioCall", label: "AudioCall" },
    { value: "TelephoneCall", label: "TelephoneCall" },
];

const requestAppointmentBtnState = {
    reassignRequest: "REASSIGN_REQUEST",
    reject: "REJECT",
    proposeNewTime: "PROPOSE_NEW_TIME",
    approve: "APPROVE",
};

const dialogWidthType = {
    small: "SMALL",
    regular: "REGULAR",
    big: "BIG",
};

const clinicReportFilterTime = [
    { value: "Year", label: t("currentYear") },
    { value: "Month", label: t("currentMonth") },
    { value: "Week", label: t("currentWeek") },
    { value: "Custom", label: t("custom") },
];

const requestAppointmentStateList = [
    { label: t("labelActive"), value: "ACTIVE" },
    { label: t("labelInactive"), value: "INACTIVE" },
];

const fileType = {
    pdf: "PDF",
    image: "IMAGE",
};

const dashboardType = {
    appointmentRequest: "appointmentRequest",
    appointment: "appointment",
    doctorAvailability: "doctorAvailability",
    month: "month",
    dateFormat: "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ",
    year: "YYYY",
    monthFormat: "MM",
};
const statuses = {
    appointmentRequest: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED"],
    appointment: ["SCHEDULED", "STARTED", "COMPLETED"],
    doctorAvailability: ["REJECTED"],
    //staust change here
};

const consultationType = {
    video: "VIDEO",
    audio: "AUDIO",
    inHouseCall: "IN_HOUSE_CALL",
    normal: "NORMAL",
    instantVideo: "INSTANT_VIDEO",
    all: "All",
    normalValue: null
};

const countryCode = {
    singapore: "65",
    india: "91",
};

const loginType = {
    doctor: "Doctor",
    clinic: "Clinic",
};

const queueSystem = {
    doctor: "Doctor",
    clinic: "Clinic",
};
const queueReset = {
    session: "Session",
    day: "Day",
};

const symptoms = [
    { name: t("Allergies"), isSelected: false, _id: "1A" },
    { name: t("Back Pain"), isSelected: false, _id: "1B" },
    { name: t("Blocked Nose"), isSelected: false, _id: "1C" },
    { name: t("Contraception"), isSelected: false, _id: "1D" },
    { name: t("Cough"), isSelected: false, _id: "1E" },
    { name: t("Diarrhoea"), isSelected: false, _id: "1F" },
    { name: t("Dizziness"), isSelected: false, _id: "1G" },
    { name: t("Eye Conditions"), isSelected: false, _id: "1H" },
    { name: t("Fever"), isSelected: false, _id: "1I" },
    { name: t("Fitness to Fly"), isSelected: false, _id: "1J" },
    { name: t("Flu / Cold"), isSelected: false, _id: "1K" },
    { name: t("Health Screening"), isSelected: false, _id: "1L" },
    { name: t("Joint / Muscle Pain"), isSelected: false, _id: "1L" },
    { name: t("Body Scan"), isSelected: false, _id: "1J" },
];

const createAppointmentType = {
    calendar: "CALENDAR",
    slot: "SLOT",
};

const paymentStatus = {
    wavedOff: "WAVED_OFF",
    successful: "successful",
};

const country = {
    singapore: "65",
    india: "91",
};

const listOfYears = Array.from({ length: 100 }, (_, i) => ({
    value: currentYear - i,
    label: currentYear - i,
}));
const getSlotDurationList = () => {
    let startVal = 15;
    let endVal = 120;
    let add = 5;
    let slotData = [];
    for (let i = startVal; i <= endVal; i += add) {
        let itemVal = { label: i + strings.format.minute, value: i };
        slotData.push(itemVal);
    }
    return slotData;
};
const MonthList = () => {
    const months = moment.months().map((month) => ({
        value: month,
        label: month,
    }));
    return months;
};

const vitalSignsTabButtonValues = {
    oneDay: "ONE_DAY",
    last7Days: "LAST_SEVEN_DAYS",
    last30Days: "LAST_THIRTY_DAYS",
};

const vitalSignsTabButtonList = [
    {
        title: "Today",
        id: vitalSignsTabButtonValues.oneDay,
        selected: true,
    },
    {
        title: "7 Days",
        id: vitalSignsTabButtonValues.last7Days,
    },
    {
        title: "30 Days",
        id: vitalSignsTabButtonValues.last30Days,
    },
];

const filter = {
    viewAllFilterList: [
        {
            status: false,
            allType: true,
            label: strings.miscellaneous.all,
        },
        {
            status: false,
            allType: false,
            label: strings.clinicReport.age,
        },
        {
            status: false,
            allType: false,
            label: strings.miscellaneous.symptoms,
        },
        {
            status: false,
            allType: false,
            label: strings.welcome.label_doctor,
        },
        {
            status: false,
            allType: false,
            label: strings.clinicReport.type,
        },
        {
            status: false,
            allType: false,
            label: strings.miscellaneous.consultType,
        },
        {
            status: false,
            allType: false,
            label: strings.clinicReport.status,
        },
        {
            status: false,
            allType: false,
            label: strings.clinicReport.consultFee,
        },
        {
            status: false,
            allType: false,
            label: strings.addDoctor.label_schedule,
        },
        {
            status: false,
            allType: false,
            label: strings.clinicReport.phoneNo,
        },
    ],
    callTypeFilterList: [
        {
            status: false,
            allType: false,
            value: consultationType.inHouseCall,
            label: strings.clinicConfiguration.label_house_call,
        },
        {
            status: false,
            allType: false,
            value: consultationType.audio,
            label: strings.clinicReport.audio,
        },
        {
            status: false,
            allType: false,
            value: consultationType.video,
            label: strings.clinicReport.video,
        },
        {
            status: false,
            allType: false,
            value: consultationType.normalValue,
            label: strings.clinicReport.normal,
        },
        {
            status: false,
            allType: false,
            value: consultationType.normalValue,
            label: strings.clinicReport.normal,
        },
        {
            status: false,
            allType: false,
            value: consultationType.video,
            label: strings.clinicReport.instantVideo,
        },
    ],
    appointmentStatusFilterList: [
        {
            status: false,
            allType: false,
            value: appointmentState.completed,
            label: strings.clinicReport.capitalizeCompleted,
        },
        {
            status: false,
            allType: false,
            value: appointmentState.confirmed,
            label: strings.clinicReport.confirmed,
        },
        {
            status: false,
            allType: false,
            value: appointmentState.waitingForClinicConfirmation,
            label: strings.miscellaneous.doctor_pending,
        },
        {
            status: false,
            allType: false,
            value: appointmentState.waitingForPatientConfirmation,
            label: strings.miscellaneous.patient_pending,
        },
        {
            status: false,
            allType: false,
            value: appointmentState.rejected,
            label: strings.clinicReport.rejected,
        },
        {
            status: false,
            allType: false,
            value: appointmentState.expired,
            label: strings.clinicReport.expired,
        },
        {
            status: false,
            allType: false,
            value: appointmentState.cancelled,
            label: strings.miscellaneous.cancelled,
        },
    ],
};

const doctorFilter = {
    viewAllDoctorFilterList: [
        {
            status: false,
            allType: true,
            label: strings.miscellaneous.all,
        },
        {
            status: false,
            allType: false,
            label: "Specialization",
        },
        {
            status: false,
            allType: false,
            label: "Qualification",
        },
        {
            status: false,
            allType: false,
            label: "Type",
        },
        {
            status: false,
            allType: false,
            label: "Experience",
        },
        {
            status: false,
            allType: false,
            label: strings.appointment.appointments,
        },
        {
            status: false,
            allType: false,
            label: "Revenue",
        },
        {
            status: false,
            allType: false,
            label: strings.clinicReport.phoneNo,
        },
    ],
};

const doctorGenderFilterList = {
    doctorGenderList: [
        {
            status: false,
            allType: false,
            label: strings.createAppointment.radioMale,
        },
        {
            status: false,
            allType: false,
            label: strings.createAppointment.radioFemale,
        },
    ],
};

const duration = {
    year: "Year",
    month: "Month",
    week: "Week",
    custom: "Custom",
};

const appointmentDetailDialog = {
    lastAppointment: "lastAppointment",
    proposedTimeLog: "proposedTimeLog",
};

const notificationType = {
    CLINIC_RECEIVED_MESSAGES: "CLINIC_RECEIVED_MESSAGES",
}

const reassignDoctorCount = 3;

const dashboardCallType = {
    callTypeFilterList: [
        {
            status: false,
            allType: true,
            label: t("all"),
            value: strings.clinicDashboard.callTypeAll,
        },
        {
            status: false,
            allType: false,
            label: t("videoCall"),
            value: consultationType.video,
        },
        {
            status: false,
            allType: false,
            label: t("audioCall"),
            value: consultationType.audio,
        },
        {
            status: false,
            allType: false,
            label: t("houseCall"),
            value: consultationType.inHouseCall,
        },
    ]
}

const gender = {
    male: "MALE",
    female: "FEMALE",
    others: "OTHERS"
}

const units = {
    kgM2: "kg/m²",
}

const commonPageType = {
    pageNotFond: "PAGE_NOT_FOUND",
    forbidden: "FORBIDDEN",
    internalServerError: "INTERNAL_SERVER_ERROR",
    serverDown: "SERVER_DOWN",
}

const maxSizeInBytes = 5 * 1024 * 1024; // 5MB in bytes

const constants = {
    resendCodeTime,
    dayList,
    emptyDayList,
    timeValue,
    appointmentState,
    dosageList,
    chatRole,
    dateFormat,
    doctorType,
    slotOptions,
    requestAppointmentBtnState,
    dialogWidthType,
    clinicProfileEditList,
    appointmentDetailsType,
    doctorDepartmentList,
    requestAppointmentStateList,
    fileType,
    consultationType,
    clinicState,
    symptoms,
    createAppointmentType,
    dayListArr,
    loginType,
    languageList,
    paymentStatus,
    listOfYears,
    currentYear,
    monthCurrentIs,
    yearIs,
    currentDate,
    getSlotDurationList,
    MonthList,
    country,
    countryCode,
    currentMonth,
    dateTosend,
    consulationOptions,
    doctorLeaveMinDate,
    doctorLeaveMaxDate,
    dashboardType,
    clinicReportFilterTime,
    doctorEditList,
    doctorTiming,
    languageOptions,
    vitalSignsTabButtonValues,
    vitalSignsTabButtonList,
    appointmentDetailDialog,
    reassignDoctorCount,
    filter,
    doctorFilter,
    duration,
    doctorGenderFilterList,
    sortedLanguageOptions,
    dashboardCallType,
    notificationType,
    hourOptions,
    gender,
    queueSystem,
    queueReset,
    commonPageType,
    units,
    maxSizeInBytes,
    statuses,
};

export default constants;
